import { useQuery } from "react-query"
import { fetchAdminSettings } from "../queries/admin_settings.queries"

export const useAdminSettings = () => {
  return useQuery(["admin-settings"], () => {
    try {
        return fetchAdminSettings()
    } catch (err) {
        return null;
    }
  })
}